module.exports = __webpack_public_path__ + "media/src/pages/GuidedOnboarding/images/logisticsMonitorWifi-3b77312298be9fd0ef1cbafee1176984.png";